import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { BUG_REPORTS_API_ENDPOINTS as cfg } from './config';

export const bugReportsApi = generatedApi;

export const hookExports: HookExports<typeof cfg, typeof bugReportsApi> = createHookExports(
  cfg,
  bugReportsApi,
);

export const bugReportsApiEndpoints = createEndpointExports(cfg, bugReportsApi);
